import { TimelineMax } from 'gsap';
import { random } from 'lodash';

const CoordsEnter = (element) => {
  // const spans = Array.from(element.querySelectorAll('.coords span:not(.number)'));
  const numbers = Array.from(element.querySelectorAll('.coords span.number'));
  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start');

  for (let i = 0; i < 20; i += 1) {
    // spans.forEach(span => tl.to(span, 0, {
    //   innerText: String.fromCharCode(random(97, 122)),
    // }, `start+=${0.1 * i}`));
    numbers.forEach(number => tl.to(number, 0, {
      innerText: random(0, 9),
    }, `start+=${0.1 * i}`));
  }

  const spansIndexes = [];
  // spans.forEach((span, index) => spansIndexes.push(index));
  const randoms = [];

  for (let i = spansIndexes.length - 1; i >= 0; i -= 1) {
    const r = random(0, spansIndexes.length - 1);
    randoms.push(spansIndexes[r]);
    spansIndexes.splice(r, 1);
  }

  // randoms.forEach(r => tl.to(spans[r], 0, {
  //   innerText: spans[r].innerText,
  // }, '+=0.05'));
  numbers.forEach((number, index) => tl.to(number, 0, {
    innerText: numbers[index].innerText,
  }, '+=0.05'));

  return tl;
};

export default CoordsEnter;
